import { useRef, useState } from "react";
import type { Vendor } from "@/api/types";
import { taxStatusLabel } from "@/lib/vendorTax";
import { retryVendorTaxes, useVendorTaxStore } from "@/lib/vendorTaxStore";
import { VendorTaxDialog } from "./VendorTaxDialog";
import "./VendorTaxControl.css";

export interface VendorTaxControlProps { vendor: Vendor; }

export function VendorTaxControl({ vendor }: VendorTaxControlProps) {
  const store = useVendorTaxStore();
  const tax = store.rows.get(vendor.id);
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  function close(): void {
    setOpen(false);
    queueMicrotask(() => trigger.current?.focus());
  }
  return (
    <>
      <div className="vendor-tax-control" role="group" aria-label="Tax info" data-state={tax?.status ?? "loading"}>
        {tax ? <span>{taxStatusLabel(tax)}{tax.tin.masked ? ` · ${tax.tin.masked}` : ""}</span> :
          store.error ? <span role="alert">{store.error}</span> : <span>Loading tax info...</span>}
        <button ref={trigger} type="button" className="btn btn--ghost" onClick={() => setOpen(true)}>Edit tax info</button>
        {store.state === "error" && <button type="button" className="btn btn--ghost" onClick={retryVendorTaxes}>Retry tax info</button>}
      </div>
      {open && <VendorTaxDialog vendor={vendor} initialTax={tax} onClose={close} />}
    </>
  );
}
